import * as React from "react";
import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { store } from "react-notifications-component";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Dispatch } from "redux";
import { prayerAndTalkAction } from "../../actions/prayerAndTalksAction";
import {
	DABBackToList,
	DABButton,
	DABDropDown,
	LoadingSpinnerModal
} from "../../components/dab";
import { getLoggedUserId } from "../../services/selectors/Accounts";
import { showAlert } from "../common/functions";

interface PrayerandTalksProps {
	dispatch: Dispatch<any>;
	prayerData: any;
	callback: any;
}

const PrayerandTalksDetail: React.SFC<PrayerandTalksProps> = ({
	dispatch,
	prayerData,
	callback,
}) => {
	const history = useHistory();
	const [formSubmit, setFormSubmit] = useState(false);
	const [isDetailLoaded, setDetailLoaded] = useState(false);
	const [prayerChannel, setPrayerChannel] = useState(null);
	const [talkChannel, setTalkChannel] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const [channelData, setChannelData] = useState<any[]>([]);

	React.useEffect(() => {
		const frompath = sessionStorage.getItem("fromPath");
		if (!prayerData?.channelData?.channels) {
			dispatch(prayerAndTalkAction.prayerAndTalkGetChannel());
		}
		if (!!prayerData?.channelData?.channels) {
			dispatch(prayerAndTalkAction.prayerAndTalkGetDetail());
		}
		setShowModal(true);
		if (frompath) {
			sessionStorage.removeItem("fromPath");
		}
	}, [prayerData?.channelData?.channels]);

	React.useEffect(() => {
		if (prayerData?.channelData) {
			const formettedChannels: any = prayerData?.channelData?.channels?.map((channel) => ({
				text: channel.channelName,
				value: channel.channelId,
				disabled: !channel?.isActive,
			}));
			setChannelData([{ text: '', value: '' }, ...formettedChannels]);
		}
	}, [prayerData?.channelData]);
	
	React.useEffect(() => {
		if (prayerData?.isUpdateStatus) {
			dispatch(prayerAndTalkAction.prayerAndTalkGetDetail());
			var alertMessage = window.localStorage.getItem("alertMessage");
			if (alertMessage && alertMessage != "") {
				store.addNotification({
					title: "Success!",
					message: alertMessage,
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				prayerData.isUpdateStatus = false
				window.localStorage.setItem("alertMessage", "");
			}
		}
	}, [prayerData?.isUpdateStatus])

	if (prayerData) {
		if (prayerData.isError && !prayerData.isSuccess) {
			if (showModal) {
				setShowModal(false);
			}
			prayerData.isError = false;
			if (prayerData.status === "Unauthorized") {
				sessionStorage.setItem(
					"fromPath",
					window.location.pathname + window.location.search
				);
				history.push("/401");
			} else {
				showAlert(prayerData.status, true);
			}
		}

		if (!prayerData.isError && prayerData.isSuccess) {
			if (showModal) {
				setShowModal(false);
			}
		}

		// GET DETAIL HANDLE
		if (prayerData.isDetailComplete) {
			if (!isDetailLoaded && prayerData) {
				if (prayerData.prayerInput !== null) {
					setPrayerChannel(prayerData?.prayerInput?.prayerAndMeditation?.channelId)
					setTalkChannel(prayerData?.prayerInput?.talks?.channelId)
					setDetailLoaded(true);
					prayerData.isSuccess = false;
					prayerData.status = null;
				}
			}
		}

		// EXECUTE AFTER SUCCESSFULL SUBMIT
		if (
			showModal &&
			formSubmit &&
			!prayerData.isFormSubmit &&
			prayerData.isSuccess
		) {
			if (prayerData.isSuccess) {
				if (showModal) {
					setShowModal(false);
				}
				window.localStorage.setItem("alertMessage", prayerData.status);
			}
		}
	}

	const handleSubmit = async (event) => {
		event.preventDefault();
		setShowModal(true);
		let data = {
			authorUserId: parseInt(getLoggedUserId()),
			prayerChannelAssignment: {
			  channelAssignmentId: prayerData?.prayerInput?.prayerAndMeditation?.channelAssignmentId,
			  sectionType: 1,
			  channelId: prayerChannel
			},
			talkChannelAssignment: {
			  channelAssignmentId: prayerData?.prayerInput?.talks?.channelAssignmentId,
			  sectionType: 2,
			  channelId: talkChannel
			}
		  }
		dispatch(prayerAndTalkAction.prayerAndTalkSave(data));
		setFormSubmit(true);
	};

	return (
		<>
			<div className="prayer-detail mb-5">
				{showModal && (
					<LoadingSpinnerModal isShowModal={showModal} modalChange={() => { }} />
				)}
				<div className="card-box m-0">
					<DABBackToList onClick={(e) => { history.goBack(); }} />
					<form
						name="createform"
						onSubmit={handleSubmit}
						className="create-form"
					>
						<div className="row mb-3">
							<div className="col-6">
								<label className="form-label col-form-label" data-testid="prayerLabel">Prayer/Meditation Channel</label>
								<div data-testid="prayerContainer">
								<DABDropDown
									id={`channel`}
									value={prayerChannel}
									isRequired={true}
									onChange={e => setPrayerChannel(e.target.value)}
									options={channelData}
								/>
								</div>
							</div>
						</div>
						<div className="row mb-3">
							<div className="col-6">
								<label className="form-label col-form-label" data-testid="talksLabel">Talks Channel</label>
								<div data-testid="talksContainer">
								<DABDropDown
									id={`talk`}
									value={talkChannel}
									isRequired={true}
									onChange={e => setTalkChannel(e.target.value)}
									options={channelData}
								/>
								</div>
							</div>
						</div>
						<div className="row bd-buttons mt-3">
							<div className="col-6 d-flex justify-content-end" data-testid="saveButtonContainer">
								<DABButton
									id="submit"
									className="btn-submit-frm"
									value="SAVE"
								>
									Save
								</DABButton>
							</div>
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state: any) => {
	const { prayerData } = state;
	return {
		prayerData,
	};
};

export default connect(mapStateToProps)(PrayerandTalksDetail);
